<mat-card>
	<mat-card-header>
		<mat-card-title
			>{{ this.index() + 1 }} {{ this.checklistItem()?.question }}</mat-card-title
		>
	</mat-card-header>

	<mat-card-content class="checklist-item-content">
		<div class="item-actions">
			<mat-button-toggle-group (change)="updateAnswer($event)">
				<mat-button-toggle [value]="true" [checked]="checklistItem()?.answer">{{
					'ok' | translate
				}}</mat-button-toggle>
				<mat-button-toggle
					class="error-toggle-button"
					[value]="false"
					[checked]="checklistItem()?.answer === false"
					>{{ 'failed' | translate }}</mat-button-toggle
				>
			</mat-button-toggle-group>

			<button
				class="outline-icon-button"
				mat-icon-button
				[disabled]="checklistItem().answer === null || checklistItem().comment !== ''"
			>
				<mat-icon svgIcon="add" (click)="openComment.set(!openComment())"></mat-icon>
			</button>
		</div>

		@if (openComment()) {
			<mat-form-field class="comment-container">
				<input
					matInput
					placeholder="Kommentar"
					[formControl]="checklistComment"
					(blur)="updateComment()"
				/>
			</mat-form-field>
		}
	</mat-card-content>
</mat-card>
